<template>
  <div>
    <div>
      <meta name="imgUrl" :content="`${IMAGEURL}`" />
      <section id="topbar" class="">
        <div class="container clearfix">
          <div class="contact-info float-left">
            <i class="fa fa-envelope-o"></i>
            <a :href="`mailto:${contact[0].custom_field}`">{{
              contact[0].custom_field
            }}</a>
            <i class="fa fa-phone"></i>
            <a href="">{{ contact[0].short_description }}</a>
          </div>
          <div class="social-links float-right">
            <span v-for="item in social">
              <a
                :href="`${item.short_description}`"
                :class="`${item.title}`"
                target="_blank"
                ><i :class="`fa fa-${item.title}`"></i
              ></a>
            </span>
          </div>
        </div>
      </section>

      <header class="header">
        <div class="container">
          <div class="row align-items-center">
            <div class="logo col-auto text-left">
              <h1>
                <a href="/">
                  <img v-bind:src="`${IMAGEURL}/assets/img/logo.png`" alt="logo"/>
                </a>
              </h1>
            </div>
            <div class="col-auto d-lg-none ml-auto mobile-toggler">
              <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarHover"
                aria-controls="navbarDD"
                aria-expanded="false"
                aria-label="Navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
            </div>
          </div>
        </div>
      </header>

      <div data-toggle="sticky-onscroll">
        <div class="container">
          <nav class="navbar navbar-expand-lg navbar-dark pl-0 pr-0">

            <div class="collapse navbar-collapse" id="navbarHover">
              <div class="mobile-nav-close d-lg-none text-right">
                <a href="javascript:;" data-toggle="collapse" data-target="#navbarHover" class="close-nav">
                  <i class="fa fa-times"></i>
                </a>
              </div>
              <ul class="navbar-nav mr-auto">
              <li class="nav-item top-menu-item text-left scroll-logo">
                <a href="/">
                  <img v-bind:src="`${IMAGEURL}/assets/img/logo.png`" alt="logo"/>
              </a>
              </li>
                <li class="nav-item dropdown">
                  <a
                    class="nav-link dropdown-toggle"
                    href="#"
                    id="menuone"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    বই
                  </a>
                  <div class="dropdown-menu" aria-labelledby="menuone">
                    <a
                      v-for="(item, index) in homeSections"
                      v-bind:key="index"
                      class="dropdown-item"
                      :href="`${baseUrl}section/${item.id}`"
                      >{{ item.title }}</a
                    >
                  </div>
                </li>

                <!-- <li class="nav-item dropdown megamenu">
                  <a
                    class="nav-link dropdown-toggle"
                    href=""
                    id="menuthree"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    বিষয়
                  </a>
                  <div class="dropdown-menu" aria-labelledby="menuthree">
                    <div class="container">
                      <div class="row">
                        <div class="col-md-12 mt-2">
                          <ul class="nav mt-2">
                            <li
                              v-for="row in category"
                              class="nav-item col-lg-2"
                            >
                              <a
                                class="nav-link"
                                :href="`${baseUrl}category/${row.id}/newest`"
                                v-if="row.category_name.length < 18"
                                >{{ row.category_name }}</a
                              >
                              <a
                                class="nav-link"
                                :href="`${baseUrl}category/${row.id}/newest`"
                                v-if="row.category_name.length >= 18"
                                :title="`${row.category_name}`"
                                >{{
                                  row.category_name.substr(0, 18) + "..."
                                }}</a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </li> -->

                <!-- <li class="nav-item dropdown">
                  <a
                    class="nav-link dropdown-toggle"
                    href="#"
                    id="menuabout"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    আমাদের সম্পর্কে
                  </a>
                  <div class="dropdown-menu" aria-labelledby="menuabout">
                    <a class="dropdown-item" :href="`${baseUrl}about`"
                      >আমাদের সম্পর্কে</a
                    >
                    <a class="dropdown-item" :href="`${baseUrl}gallery`"
                      >গ্যালারি</a
                    >
                    <a class="dropdown-item" :href="`${baseUrl}events`"
                      >ইভেন্টস</a
                    >
                    <a class="dropdown-item" :href="`${baseUrl}press`"
                      >প্রেস রিলিজ</a
                    >
                    <a class="dropdown-item" :href="`${baseUrl}downloads`"
                      >ডাউনলোড</a
                    >
                  </div>
                </li> -->

                <li class="nav-item dropdown">
                  <a class="nav-link" :href="`${baseUrl}gallery`"> গ্যালারি </a>
                </li>

                <li class="nav-item dropdown">
                  <a class="nav-link" :href="`${baseUrl}job-circular`"> নিয়োগ বিজ্ঞপ্তি </a>
                </li>

                <!-- <li class="nav-item dropdown">
                  <a class="nav-link" :href="`${baseUrl}contact`"> যোগাযোগ </a>
                </li> -->

                <li class="nav-item dropdown">
                  <router-link v-if="!user_id" to="/login" class="nav-link">
                    লগইন
                  </router-link>
                  <router-link
                    v-else
                    :to="{ name: 'profile' }"
                    class="nav-link"
                  >
                    অ্যাকাউন্ট
                  </router-link>
                </li>
                <li class="nav-item dropdown">
                  <router-link class="nav-link position-relative" to="/cart">
                    কার্ট<span class="cart-count scrolled">{{
                      $helper.cartCount()
                    }}</span>
                  </router-link>
                </li>
              </ul>
              <form
                class="form-inline my-2"
                :action="`${baseUrl}book-search`"
                method="GET"
              >
                <div class="input-group">
                  <input
                    class="form-control border-right-0 border"
                    type="search"
                    name="keyword"
                    autocomplete="off"
                  />
                  <span class="input-group-append">
                    <div class="input-group-text bg-transparent">
                      <i class="fa fa-search"></i>
                    </div>
                  </span>
                </div>
              </form>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import AutoSearch from "./AutoSearch.vue";

export default {
  components: {
    AutoSearch,
  },
  data() {
    return {
      contact: [
        {
          custom_field: null,
        },
      ],
      social: [],
      autoSearchRender: false,
      user_id: null,
      popup: null,
      customer_id: null,
      keyword: null,
      homeSections: [],
      category: [],
      autoProducts: [],
      downloads: [
        {
          image: ``,
        },
      ],
    };
  },
  methods: {
    showHideSearchInput() {
      $(`#scrollSearchForm`).animate({
        width: `toggle`,
      });
    },
    goTo(where) {
      this.$helper.goTo(where);
    },
    getContact() {
      fetch(`${this.APIURL}cms-resources/Contact-Us`)
        .then((response) => response.json())
        .then((json) => (this.contact = json.data));
    },
    getSocial() {
      fetch(`${this.APIURL}cms-resources/Social-Links`)
        .then((response) => response.json())
        .then((json) => (this.social = json.data));
    },
    getCategory() {
      fetch(`${this.APIURL}category-resources`)
        .then((response) => response.json())
        .then((json) => (this.category = json.data));
    },
    logout() {
      this.$helper.logout();
    },
    async autoSearch() {
      this.autoSearchRender = false;
      const response = await fetch(
        this.APIURL + "products-resources/auto-search/" + this.keyword
      );
      let data = await response.json();
      this.autoProducts = data.data;
      if (this.autoProducts.length > 0) this.autoSearchRender = true;
    },
    getHomeSections() {
      this.$http
        .get("home-sections-name")
        .then((response) => {
          this.homeSections = response.data;
          console.log(response.data);
        })
        .catch((e) => {
          this.homeSections = [];
        });
    },
  },
  mounted() {
    this.getHomeSections();
    this.getContact();
    this.getSocial();
    this.getCategory();
    if (localStorage.getItem(`user_id`) !== null) {
      this.user_id = localStorage.getItem(`user_id`);
    }

    $(document).ready(function () {
      // Custom function which toggles between sticky class (is-sticky)
      var stickyToggle = function (sticky, stickyWrapper, scrollElement) {
        var stickyHeight = sticky.outerHeight();
        var stickyTop = stickyWrapper.offset().top;
        if (scrollElement.scrollTop() >= stickyTop) {
          stickyWrapper.height(stickyHeight);
          sticky.addClass("is-sticky");
          $(".scroll-logo").show();
        } else {
          sticky.removeClass("is-sticky");
          $(".scroll-logo").hide();
          stickyWrapper.height("auto");
        }
      };

      // Find all data-toggle="sticky-onscroll" elements
      $('[data-toggle="sticky-onscroll"]').each(function () {
        var sticky = $(this);
        var stickyWrapper = $("<div>").addClass("sticky-wrapper"); // insert hidden element to maintain actual top offset on page
        sticky.before(stickyWrapper);
        sticky.addClass("sticky");

        // Scroll & resize events
        $(window).on(
          "scroll.sticky-onscroll resize.sticky-onscroll",
          function () {
            stickyToggle(sticky, stickyWrapper, $(this));
          }
        );

        // On page load
        stickyToggle(sticky, stickyWrapper, $(window));
      });
    });
  },
};
</script>
